import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './apiAuth';
import { authHeader, userEmail, canonicalizeResponse } from './common';
import { notification } from 'antd';

export const listSurveys = createAsyncThunk(
  'survey/listSurveys',
  async (filterdata, { rejectWithValue }) => {
    console.log("authHeader()", await authHeader())
    try {
      const response = await api.post('/profile-surveys/available', filterdata, {
        headers: await authHeader(),
      });
      return canonicalizeResponse(response);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to list surveys');
    }
  }
);
export const surveyDetail = createAsyncThunk(
  'survey/surveyDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/profile-surveys/${id}`, {
        headers: await authHeader(),
      });
     
      return canonicalizeResponse(response);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to notify user');
    }
  }
);

 
export const saveSurvey = createAsyncThunk(
  'survey/saveSurvey',
  async ({ surveyId, responsedata }, { rejectWithValue }) => {
   console.log("this function run")
    try {
      const response = await api.post(`/profile-surveys/${surveyId}/responses`, responsedata, {
        headers: await authHeader(),
      });
     notification.success({
        message: 'Survey Response Submitted Successfully',
      });
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({  message: error.response?.data?.message || 'Failed to submit survey response ' });
      return rejectWithValue(error.response?.data?.message || 'Failed to submit survey response');
    }
  }
);

// Fetch live surveys from external API
export const listLiveSurveys = createAsyncThunk(
  'survey/listLiveSurveys',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/surveys/live', {
        headers: await authHeader(),
      });
      return canonicalizeResponse(response);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch live surveys');
    }
  }
);




const initialState = {
  surveys: [], 
  liveSurveys: [],
  liveSurveysLoading: false,
  surveyLoading: null,
  detailSurvey: [],
  isLoading: false,
  saveDetail: [],
  filterData: JSON.parse(localStorage.getItem('filterData')) || null,  
  status: 'idle', 
  error: null,
};

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    // Clear current survey
    clearCurrentSurvey: (state) => {
      state.currentSurvey = null;
    },
  },
  extraReducers: (builder) => {
    // getSurvey
    builder
      // listSurveys
      .addCase(listSurveys.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.surveyLoading = true;
      })
      .addCase(listSurveys.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.surveys = action.payload;
        state.error = null;
        state.surveyLoading = false;
      })
      .addCase(listSurveys.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.surveyLoading = false;
      })
      

    .addCase(surveyDetail.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(surveyDetail.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.detailSurvey = action.payload;
        state.error = null;
      })
      .addCase(surveyDetail.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(saveSurvey.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(saveSurvey.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.saveDetail = action.payload;
        state.error = null;
      })
      .addCase(saveSurvey.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // listLiveSurveys
      .addCase(listLiveSurveys.pending, (state) => {
        state.liveSurveysLoading = true;
        state.error = null;
      })
      .addCase(listLiveSurveys.fulfilled, (state, action) => {
        state.liveSurveysLoading = false;
        state.liveSurveys = action.payload;
        state.error = null;
      })
      .addCase(listLiveSurveys.rejected, (state, action) => {
        state.liveSurveysLoading = false;
        state.error = action.payload;
      });
      
  },
});

export const { clearError, clearCurrentSurvey } = surveySlice.actions;

export default surveySlice.reducer;